/**
 * Validate cart items against Ramat Gan coupon's assigned child ID
 * @param {Array} products - Cart items with LicTradNum (child ID)
 * @param {string} assignedChildId - ID_Number from coupon validation (LicTradNum)
 * @returns {Object} { matchingProducts, mismatchedProducts, removedCount }
 */
export const validateCartForCoupon = (products, assignedChildId) => {
    const matchingProducts = products.filter(p => String(p.LicTradNum) === String(assignedChildId));
    const mismatchedProducts = products.filter(p => String(p.LicTradNum) !== String(assignedChildId));

    return {
        matchingProducts,
        mismatchedProducts,
        removedCount: mismatchedProducts.length,
        hasRemovals: mismatchedProducts.length > 0,
    };
};

/**
 * Check if a child's cart products qualify for the Ramat Gan coupon (מיסי חבר only)
 * Membership fee: ItmsGrpCod === 160 OR ItemPurposeType === 4
 */
export const hasEligibleMembershipProducts = (products, childId) => {
    const childProducts = products.filter(p => String(p.LicTradNum) === String(childId));
    return childProducts.some(
        p => Number(p.ItmsGrpCod) === 160 || Number(p.ItemPurposeType) === 4
    );
};

/**
 * Get summary text for removed products
 * @param {Array} mismatchedProducts - Products that don't match coupon's child ID
 * @param {Object} household - Household data with ChildrenList
 * @returns {string} Summary message
 */
export const getRemovedProductsSummary = (mismatchedProducts, household) => {
    if (!mismatchedProducts.length) return '';

    const groupedByChild = {};
    mismatchedProducts.forEach(product => {
        if (!groupedByChild[product.Pupil_FirstName]) {
            groupedByChild[product.Pupil_FirstName] = [];
        }
        groupedByChild[product.Pupil_FirstName].push(product.ActivName);
    });

    const summaryLines = Object.entries(groupedByChild).map(([childName, activities]) => {
        return `${childName}: ${activities.join(', ')}`;
    });

    return summaryLines.join('\n');
};
